export default __webpack_public_path__ + "static/lilypad bloom-112c76c89fba322f0bfb46302cdc1193.png";